import { BehaviorSubject } from 'rxjs'
import { startWith } from 'rxjs/operators'
import { scrolls$ } from '@app-bootstrap/scroll-tracking.bootstrap'

export class StickyBar {

    static query(offsetContainerSelector: string, stickyBarSelector: string): StickyBar {
        const offsetContainer = document.querySelector<HTMLElement>(offsetContainerSelector)
        const stickyBar = document.querySelector<HTMLElement>(stickyBarSelector)

        if (offsetContainer === null || stickyBar === null) {
            throw new Error(`Could not find elements for selectors ${offsetContainer}, ${stickyBarSelector}`)
        }

        return new this(offsetContainer, stickyBar)
    }

    private isStickySubject$ = new BehaviorSubject<boolean>(false)
    public isSticky$ = this.isStickySubject$.asObservable()

    constructor(
        public readonly offsetContainer: HTMLElement,
        public readonly stickyBar: HTMLElement,
    ) {
        scrolls$.pipe(startWith(null)).subscribe(() => this.updateSticky())
    }

    // ------------------------------------------------------------------------------
    //      Runtime
    // ------------------------------------------------------------------------------

    /**
     * Updates the sticky state of the middle segment of the header.
     */
    updateSticky() {
        const offset = window.pageYOffset + 60
        const topOffset = (
            this.offsetContainer.getBoundingClientRect().top + window.scrollY + this.offsetContainer.offsetHeight
        )

        const distance = topOffset - offset

        if ((distance <= 0) && ! this.isStickySubject$.getValue()) {
            this.stickyBar.classList.remove('hide')
            this.isStickySubject$.next(true)
        } else if (this.isStickySubject$.getValue() && (offset <= topOffset)) {
            this.stickyBar.classList.add('hide')
            this.isStickySubject$.next(false)
        }
    }
}
